import { uid } from './uid';

// ── 品牌配置（单一事实来源）──────────────────────────────────────────────────
import {
  BRAND_NAME, BRAND_ACN,
  LOGO_URL as _LOGO_URL,
  LOGO_FALLBACK_URL as _LOGO_FALLBACK_URL,
  fetchCompanyDefaults,
} from './brandConfig';

// Re-export for backward compatibility
export const LOGO_URL = _LOGO_URL;
export const LOGO_FALLBACK_URL = _LOGO_FALLBACK_URL;

// S-02: address/phone/director are now fetched from backend API
export const DEFAULT_COMPANY_INFO = {
  name: BRAND_NAME,
  acn: BRAND_ACN,
  address: '',
  phone: '',
  director: '',
  logo_url: LOGO_URL,
  logo_fallback_url: LOGO_FALLBACK_URL,
};

/**
 * Fetch company info with defaults from backend (address/phone/director).
 * Use this when creating new quotes/invoices to pre-fill company info.
 */
export async function fetchCompanyInfoWithDefaults() {
  const info = { ...DEFAULT_COMPANY_INFO };
  const defaults = await fetchCompanyDefaults();
  info.address = defaults.company_address || '';
  info.phone = defaults.company_phone || '';
  info.director = defaults.company_director || '';
  return info;
}

export const DEFAULT_CATEGORIES = [
  {
    id: uid(),
    name: 'PRELIMINARIES',
    price: 0,
    items: [
      { id: uid(), description: 'CDC Certification', comment: '' },
      { id: uid(), description: 'Project Management', comment: '' },
      { id: uid(), description: 'Structural Engineering Report', comment: '' },
      { id: uid(), description: 'Site Measure and Survey', comment: '' },
      { id: uid(), description: 'Equipment Hire', comment: '' },
      { id: uid(), description: 'Travel Allowance', comment: '' },
      { id: uid(), description: 'Transportation', comment: '' },
      { id: uid(), description: 'Insurance', comment: '' },
      { id: uid(), description: 'Rubbish Dumping', comment: '' },
      { id: uid(), description: 'Final Clean Up', comment: '' },
      { id: uid(), description: 'OC Certifications', comment: '' },
      { id: uid(), description: 'Storage', comment: '' },
    ],
  },
  {
    id: uid(),
    name: 'WALL AND CEILING',
    price: 0,
    items: [
      { id: uid(), description: 'Supply and install ceiling/bulkhead grid and plasterboard', comment: '' },
      { id: uid(), description: 'Access panels', comment: '' },
      { id: uid(), description: 'Partition wall stud and plasterboard', comment: '' },
      { id: uid(), description: 'Mirror cladding', comment: '' },
    ],
  },
  {
    id: uid(),
    name: 'PAINTING',
    price: 0,
    items: [
      { id: uid(), description: 'Paint finish to open ceiling', comment: '' },
      { id: uid(), description: 'Paint finish to internal wall and ceiling', comment: '' },
    ],
  },
  {
    id: uid(),
    name: 'TIMBER FLOOR WORKS',
    price: 0,
    items: [
      { id: uid(), description: 'Supply and install timber floor board', comment: '' },
      { id: uid(), description: 'Adjust floor level', comment: '' },
      { id: uid(), description: 'Supply and install floor underlay', comment: '' },
    ],
  },
  {
    id: uid(),
    name: 'TILING',
    price: 0,
    items: [
      { id: uid(), description: 'Supply and install waterproofing', comment: '' },
      { id: uid(), description: 'Tile floor to kitchen, bar and bathroom', comment: '' },
      { id: uid(), description: 'Wall tiles', comment: '' },
      { id: uid(), description: 'Oven mosaic tiles', comment: '' },
    ],
  },
  {
    id: uid(),
    name: 'SIGNAGE',
    price: 0,
    items: [
      { id: uid(), description: 'Install signage, TV screen, and graphics', comment: '' },
      { id: uid(), description: 'Shopfront signage note', comment: '' },
    ],
  },
  {
    id: uid(),
    name: 'Joinery Works',
    price: 0,
    items: [
      { id: uid(), description: 'Curved banquette seat', comment: '' },
      { id: uid(), description: 'Straight banquette seat', comment: '' },
      { id: uid(), description: 'U-shaped banquette seat', comment: '' },
      { id: uid(), description: 'L-shaped banquette seat', comment: '' },
      { id: uid(), description: 'Outdoor banquette seat', comment: '' },
      { id: uid(), description: 'Round POS podium', comment: '' },
      { id: uid(), description: '1800 Dia round table', comment: '' },
      { id: uid(), description: '1200 Dia round table', comment: '' },
      { id: uid(), description: 'Waiter station', comment: '' },
      { id: uid(), description: 'Bathroom mirror', comment: '' },
      { id: uid(), description: 'Feature wall cladding', comment: '' },
      { id: uid(), description: 'Ceiling feature', comment: '' },
      { id: uid(), description: 'Curtain (non-motorised)', comment: '' },
      { id: uid(), description: 'Lighting feature', comment: '' },
      { id: uid(), description: 'Bar structure and features', comment: '' },
    ],
  },
  {
    id: uid(),
    name: 'Steel and Stainless Works',
    price: 0,
    items: [
      { id: uid(), description: 'Bar stainless counter', comment: '' },
      { id: uid(), description: 'Kitchen stainless bench', comment: '' },
      { id: uid(), description: 'Kitchen stainless wall cladding', comment: '' },
      { id: uid(), description: 'Kitchen stainless shelf', comment: '' },
      { id: uid(), description: 'Unpack joineries', comment: '' },
    ],
  },
  {
    id: uid(),
    name: 'Mechanical Works',
    price: 0,
    items: [
      { id: uid(), description: 'Kitchen exhaust and duct work as per drawing', comment: '' },
    ],
  },
  {
    id: uid(),
    name: 'Plumbing Works',
    price: 0,
    items: [
      { id: uid(), description: 'Fit-off hot and cold water', comment: '' },
      { id: uid(), description: 'Fit-off all equipment', comment: '' },
      { id: uid(), description: 'Supply and install plumbing equipment and fixtures', comment: '' },
      { id: uid(), description: 'Bathroom hardware and fixtures', comment: '' },
    ],
  },
  {
    id: uid(),
    name: 'Lighting',
    price: 0,
    items: [
      { id: uid(), description: 'Purchase L1, L2, L3, L4 and L5 as per design set', comment: '' },
    ],
  },
  {
    id: uid(),
    name: 'Electrical Works',
    price: 0,
    items: [
      { id: uid(), description: 'Fit-off all lighting', comment: '' },
      { id: uid(), description: 'Exit signs and emergency lights', comment: '' },
      { id: uid(), description: 'GPOs and data points', comment: '' },
      { id: uid(), description: 'Electrical connections for equipment', comment: '' },
      { id: uid(), description: 'Signages and LED strips', comment: '' },
      { id: uid(), description: 'CCTV and Speakers', comment: '' },
    ],
  },
  {
    id: uid(),
    name: 'MISC',
    price: 0,
    items: [
      { id: uid(), description: 'Supply and install Safe', comment: '' },
      { id: uid(), description: 'Fire extinguisher and blanket', comment: '' },
    ],
  },
];

export const DEFAULT_PAYMENT_SCHEDULE = [
  { id: uid(), description: 'Deposit on acceptance of quote', percentage: 30 },
  { id: uid(), description: 'On the first day of site works', percentage: 30 },
  { id: uid(), description: 'After completion, before release OC', percentage: 35 },
];

export const DEFAULT_PROJECT_COMPLETION =
  '14 working days after the arrival of container to site or warehouse upon notification from logistic agent';

export const DEFAULT_EXCLUSIONS = [
  'All Cat1 works excluded',
  'All equipment is excluded from this quote unless it\'s been specified',
  'All security expenses which might incur due to noisy works restrictions of the centre/landlord been excluded',
  'Hoarding expenses are excluded',
  'All marketing materials, e.g. vinyl printing, are excluded',
  'Aircon works is excluded in this quote',
];

// ── Payment defaults are fetched from backend API (GET /api/settings/payment-defaults) ──
// This keeps bank details out of the JS bundle for security.
// Use fetchPaymentDefaults() below to get them at runtime.
export const DEFAULT_PAYMENT_DETAILS = {
  bank_name: '',
  account_name: '',
  bsb: '',
  account_number: '',
};

const API_BASE = process.env.REACT_APP_BACKEND_URL;

let _paymentDefaultsCache = null;

/**
 * Fetch payment defaults from backend (authenticated).
 * Returns { bank_name, account_name, bsb, account_number }.
 * Results are cached in-memory for the session.
 */
export async function fetchPaymentDefaults() {
  if (_paymentDefaultsCache) return _paymentDefaultsCache;
  try {
    const token = localStorage.getItem('revolead_auth_token');
    const res = await fetch(`${API_BASE}/api/settings/payment-defaults`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    _paymentDefaultsCache = await res.json();
    return _paymentDefaultsCache;
  } catch (err) {
    console.warn('Failed to fetch payment defaults:', err);
    return { ...DEFAULT_PAYMENT_DETAILS };
  }
}

export const DEFAULT_ACCEPTANCE = {
  client_name: '',
  date: '',
  authorised_date: '',
  client_signature: '',
  company_signature: '',
};

export const DEFAULT_VALIDITY_NOTE =
  'This quotation remains valid for 15 days from above date after which a revised quote may be necessary. Any variation to the above mentioned scope of works or additional services may result in a variation to the quoted price.';

export const DEFAULT_GENERAL_CONDITIONS = `Standard Terms and Conditions of Contract

1. Payments
   1.1 Contract Price
   You agree to pay the Contract Price in accordance with the payment schedule set out in the Quotation.
   1.2 Deposit
   A non refundable Deposit is payable upon acceptance of the Quotation to secure commencement of the Works.
   1.3 Progress Payments
   Progress claims will be issued at the intervals or milestones specified in the Quotation. Each progress claim constitutes a payment claim under the Building and Construction Industry Security of Payment Act 1999 (NSW).
   1.4 Payment Terms
   All invoices are payable within 7 Business Days of the invoice date unless otherwise stated in the Quotation.
   1.5 Late Payments
   If payment is not received by the due date, we may, without limiting other rights:
   - Charge interest at the rate noted on the invoice, calculated daily until payment is made.
   - Suspend Works until all outstanding amounts are paid. We are not responsible for delays arising from such suspension.
   - Recover all reasonable costs incurred in recovering overdue amounts, including legal costs on a solicitor/client basis.
   1.6 Retention of Title
   - Ownership of materials, fittings, and fixtures supplied by us remains with us until all amounts owed are paid in full.
   - Until fully paid, you hold these items as our bailee and must store them in a way that clearly identifies them as our property.
   - If payment remains outstanding, you irrevocably authorise us to enter the Site or any relevant premises to recover such items.

2. Schedules, Access, and Site Conditions
   2.1 Project Schedule
   We will provide an indicative project schedule outlining key milestones and the anticipated Practical Completion date. This schedule is an estimate and may be updated.
   2.2 Delays
   We will take reasonable steps to meet the schedule; however, we are not liable for delays caused by:
   - Actions or omissions by you or your representatives;
   - Variations to the Scope of Works;
   - Force majeure events (e.g., natural disasters, industrial action, fire, flood, government restrictions);
   - Delays in obtaining statutory or landlord approvals;
   - Delays in the supply of labour or materials;
   - Unforeseen site conditions;
   - Category 1 works or base building works carried out by others.
   We will notify you of delays and are entitled to a reasonable extension of time.
   2.3 Site Access
   We must be provided clear, safe, and continuous access to the Site for the duration of the Works, including:
   - Access to loading docks, lifts, and common areas;
   - Access during required working hours;
   - Reasonable amount of time during day for noisy works without security.
   Any costs or delays caused by restricted access or building management requirements is client responsibility.
   2.4 Site Conditions
   Unless otherwise stated, we expect the site fully defitted when we attend the site for site set up and measurements. If a second visit is required due to site conditions, it might cause variation due to the location of the site.

3. Materials
   3.1 Supply of Materials
   We will supply all materials required for the works as per set out in the scope of works.
   3.2 Material Quality
   Materials will comply with the Building Code of Australia and relevant Australian Standards.
   3.3 Client-Supplied Materials
   If you supply materials:
   - You are responsible for their suitability and quality.
   - We are not liable for defects or delays arising from such materials.
   - Additional labour or rework caused by these materials will be charged as a variation.
   3.4 Substitution of Materials
   If a specified material is unavailable, we may propose a substitute of equivalent or superior quality, subject to your approval (not unreasonably withheld).

4. Approvals
   4.1 Client Approvals
   You must provide all required decisions, approvals, drawings, and information in a timely manner to avoid delays.
   4.2 Statutory Approvals
   Unless otherwise specified, you are responsible for obtaining all statutory, landlord, or centre management approvals. Assistance can be provided by us for an additional fee.

5. Workmanship, Safety and Site Management
   5.1 Workmanship
   All works will be carried out with reasonable skill and care by qualified personnel.
   5.2 OH&S Compliance
   We comply with all applicable work health and safety laws. You must ensure the Site is safe for our employees, subcontractors, and suppliers.
   5.3 Protection of Property
   We will take reasonable care to avoid damage to existing structures. However, we are not liable for:
   - Latent defects in existing structures;
   - Damage caused by issues already present prior to commencement of fit-out works.
   5.4 After-Hours Work
   Any required after-hours work, including building management supervision fees, will be charged as a variation unless included in the Quotation.

6. Liability & Insurance
   6.1 Limitation of Liability
   To the maximum extent permitted by law, our total liability for Claims arising out of or in connection with the Agreement or Works is limited to the Contract Price.
   6.2 Exclusion of Consequential Loss
   We are not liable for indirect or consequential losses, including loss of profit, revenue, business opportunity, or goodwill.
   6.3 Insurance
   We maintain:
   - Public Liability Insurance of at least AUD $10,000,000;
   - Workers' Compensation Insurance as required by law;
   - Contract Works Insurance for the duration of the Works. Certificates of currency are available upon request.

7. Warranty
   7.1 Defects Liability Period
   We warrant the Works to be free from defects for 1 year from Practical Completion, unless stated otherwise in the quote.
   7.2 Rectification
   Defects notified within the Defects Liability Period will be rectified within a reasonable timeframe at no additional cost.
   7.3 Warranty Exclusions
   This warranty does not cover:
   - Misuse, neglect, or lack of maintenance;
   - Fair wear and tear;
   - Defects in client-supplied materials;
   - Damage caused by others;
   - Equipment or products covered under supplier warranties.
   7.4 Statutory Rights
   This warranty is in addition to your rights under the Australian Consumer Law.

8. Variations
   8.1 Variations Requested by You
   Requests must be made in writing.
   8.2 Variation Quote
   We will provide a written variation quotation detailing cost and schedule adjustments.
   8.3 Approval
   No variation will be carried out until approved by you in writing.
   8.4 Variations Due to Site Conditions
   Unforeseen site conditions resulting in additional costs or time will be treated as a variation.

9. Dispute Resolution
   9.1 Notice of Dispute
   A party claiming a dispute must issue written notice outlining the issue.
   9.2 Negotiation
   Parties must meet within 7 Business Days to attempt resolution.
   9.3 Mediation
   If the dispute cannot be resolved within 30 Business Days, either party may refer the dispute to mediation through the Australian Disputes Centre.
   9.4 Litigation
   Court proceedings (other than urgent interlocutory relief) may only commence after complying with this process.

10. Termination
    10.1 Termination by Us
    We may terminate this Agreement if you:
    - Fail to pay any amount within 21 Business Days of the due date;
    - Breach a material term and fail to remedy within 7 Business Days of notice;
    - Become insolvent or enter arrangements with creditors.
    10.2 Consequences of Termination
    You must pay for all Works completed, materials supplied, and reasonable costs incurred up to termination.

11. General
    11.1 Governing Law
    This agreement is governed by the laws of New South Wales, Australia.
    11.2 Entire Agreement
    This agreement supersedes all prior communications and constitutes the entire agreement between the parties.
    11.3 Severability
    If any clause is invalid, the remaining clauses continue to apply.
    11.4 Notices
    Notices must be in writing and delivered personally, by pre-paid post, and/or email to the address specified in the quotation.

    The above terms and conditions are executed as part of the contract for works with ${BRAND_NAME}.`;

export function formatCurrency(amount) {
  return '$' + Number(amount).toLocaleString('en-AU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function getDefaultQuoteData() {
  const today = new Date().toISOString().split('T')[0];
  return {
    id: null,
    quote_no: '',
    date: today,
    client_name: '',
    client_abn: '',
    contact_person: '',
    client_address: '',
    project_name: '',
    project_address: '',
    revision: '',
    company_info: { ...DEFAULT_COMPANY_INFO },
    categories: DEFAULT_CATEGORIES.map(cat => ({
      ...cat,
      id: uid(),
      items: cat.items.map(item => ({ ...item, id: uid() })),
    })),
    gst_enabled: true,
    payment_schedule: DEFAULT_PAYMENT_SCHEDULE.map(n => ({ ...n, id: uid() })),
    project_completion: DEFAULT_PROJECT_COMPLETION,
    exclusions: DEFAULT_EXCLUSIONS.map(text => ({ id: uid(), text })),
    validity_note: DEFAULT_VALIDITY_NOTE,
    general_conditions: DEFAULT_GENERAL_CONDITIONS,
    payment_details: { ...DEFAULT_PAYMENT_DETAILS },
    acceptance: { ...DEFAULT_ACCEPTANCE },
  };
}

export function getHistoryItems(key) {
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : [];
  } catch (e) {
    console.warn(`Failed to read history for ${key}:`, e);
    return [];
  }
}

export function updateHistory(key, newItems) {
  try {
    const existing = getHistoryItems(key);
    const merged = [...new Set([...newItems, ...existing])].slice(0, 50);
    localStorage.setItem(key, JSON.stringify(merged));
  } catch (e) {
    console.warn(`Failed to update history for ${key}:`, e);
  }
}

/** Normalize string[] exclusions (from API) to {id, text}[] for stable React keys */
export function normalizeExclusions(exclusions) {
  return (exclusions || []).map(e =>
    typeof e === 'string' ? { id: uid(), text: e } : e
  );
}

/** Convert {id, text}[] back to string[] for API storage */
export function denormalizeExclusions(exclusions) {
  return (exclusions || []).map(e =>
    typeof e === 'object' ? e.text : e
  );
}

/** Ensure payment schedule nodes have stable IDs */
export function normalizePaymentSchedule(schedule) {
  return (schedule || []).map(node => ({
    ...node,
    id: node.id || uid(),
  }));
}
